<template>
  <page>
    <page-title v-t="'p.teamsPage.title'"/>

    <list-item
      v-for="team in teams"
      :key="team.id"
      :avatar-name="team.name"
      :title="team | teamName"
      :title-clickable="true"
      :subline="$tc('c.team.label.members', team.membershipsCount, {count: team.membershipsCount})"
      :dropdown-options="dropdownOptions(team)"
      class="team"
      @dropdown-select="action => dropdownSelect({team, action})"
      @on-click="editTeam(team)"
    />

    <team-modal />

    <button
      class="add-content-button"
      @click.prevent="openTeamModal"
    />
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import teamName from '@/filters/teamName'
import PageMixin from '@/mixins/pages/Page'
import TeamModal from '@/components/teams/TeamModal'
import ListItem from '@/components/ui/ListItem'

export default {
  name: 'TeamsPage',
  mixins: [PageMixin],
  filters: {
    teamName
  },
  components: {
    TeamModal,
    ListItem
  },
  computed: {
    ...mapState({
      teams: state => state.teams.teams
    })
  },
  methods: {
    ...mapActions([
      'fetchTeams',
      'destroyTeam',
      'openTeamModal',
      'openConfirmModal',
      'closeConfirmModal'
    ]),
    dropdownOptions (team) {
      return team.visibility === 'is_personal'
        ? [
            { label: 'Bearbeiten', value: 'edit', icon: 'edit' }
          ]
        : [
            { label: 'Bearbeiten', value: 'edit', icon: 'edit' },
            { label: 'Team verlassen', value: 'leave', icon: 'arrow-circle-right' },
            { label: 'Löschen', value: 'delete', icon: 'trash' }
          ]
    },
    dropdownSelect ({ team, action }) {
      switch (action) {
        case 'edit':
          // this.openTeamModalTeam(this.team.id)
          this.editTeam(team)
          break
        case 'delete':
          this.openConfirmModal({
            title: 'Team löschen',
            message: `Das Team ${team.name} wirklich löschen?`,
            callback: () => {
              this.destroyTeam(team.id)
                .then(this.fetchTeams)
                .then(this.closeConfirmModal)
            }
          })
          break
        default:
          window.alert(`action: ${action}`)
      }
    },
    editTeam (team) {
      this.$router.push({ name: 'TeamSettings', params: { teamId: team.id } })
    }
  },
  created () {
    this.fetchTeams()
      .then(() => {
        this.$emit('loadingDone')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/teams/TeamsPage.vue